import cart from '@ppcp/cart';
import order from '@ppcp/order';
import {isPluginConnected, getSetting, getPage} from '@ppcp/utils';
import {CheckoutController} from '@ppcp/controllers';
import Context from '@ppcp/context';
import PayPalGateway from '../gateways/PayPalGateway';
import {registerPaymentMethod} from '@ppcp/payment-methods';


if (isPluginConnected()) {
    const settings = getSetting('ppcp_data');

    // Create PayPal gateway
    const gateway = new PayPalGateway({
        id: 'ppcp',
        cart,
        settings: settings,
        controller: null // Will be set after controller creation
    });

    // Create checkout controller with gateway
    const controller = new CheckoutController({
        id: 'ppcp',
        cart,
        order,
        context: new Context(getPage()),
        gateway,
        settings
    });

    registerPaymentMethod(gateway);

    controller.initialize();


    setInterval(() => {
        if (controller.paypal) {
            controller.createPaymentElement();
        }
    }, 2000);
}